import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { CampaignList } from './CampaignList';
import PageContainer from '@shared/components/container/PageContainer';
import { useWelcomeToast } from '@features/Auth/Welcome';
import { useAppDispatch, useAppSelector } from '@shared/store';
import { actions } from '@shared/store/ducks';

import { useStyles } from './styles';
import { FilterCard } from '@shared/components/filterCard/FilterCard';
import { ResponseMsg } from '@shared/types/admin/agent';
import CustomAlert from '@shared/components/alert/alert';

export const CampaignPage: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  useWelcomeToast();
  const [responseMsg, setResponseMsg] = useState<ResponseMsg>({
    message: '',
    type: 'success',
  });

  const currentCompany = useAppSelector((state) => state.auth.authenticatedUserCompany);

  useEffect(() => {
    if (responseMsg.message) {
      const timer = setTimeout(() => {
        setResponseMsg({ message: '', type: 'success' });
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [responseMsg]);

  useEffect(() => {
    dispatch(actions.customizer.toggleLayout('full'));
  }, [dispatch]);

  const setLoading = async (_flag: boolean) => {};

  const onCampaignDeleteError = (error: ResponseMsg) => {
    setResponseMsg(error);
  };

  return (
    <>
      <PageContainer
        title={t('adminMainPage.menuItems.campaignList')}
        companyName={currentCompany?.title}
        description={t('adminMainPage.menuItems.campaignList')}>
        {/* <Breadcrumb
          title={t('adminMainPage.header.companyName', { companyName: currentCompany?.title })}
          items={BCrumb}>
          <></>
        </Breadcrumb> */}
        <Box className={classes.main}>
          {responseMsg.message ? (
            <CustomAlert message={responseMsg.message} type={responseMsg.type} />
          ) : (
            ''
          )}
          <FilterCard />
          <CampaignList setLoading={setLoading} onCampaignDeleteError={onCampaignDeleteError} />
        </Box>
      </PageContainer>
    </>
  );
};
